import React from 'react'
import styled from 'styled-components'
import InlineGroup from 'components/Common/InlineGroup'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { useTranslation } from 'react-i18next'

import {
  SectionContent,
  Img,
  Section,
} from './styles'
import ClickableLink from 'components/Common/Clickable/ClickableLink'
import BodyText from 'components/Luxkit/Typography/BodyText'

const LinkContainers = styled(InlineGroup)`
  justify-content: center;

  ${mediaQueryUp.sm} {
    justify-content: flex-start;
  }
`

const AppLinks = styled(ClickableLink)`
  display: block;
`

export default () => {
  const { t } = useTranslation('footer')

  return (
    <Section>
      <BodyText variant="large" as="h4" weight="bold">{t('Download Our Free Mobile App')}</BodyText>
      <SectionContent>
        <LinkContainers size="sm">
          <AppLinks href="https://app.luxuryescapes.com/3WHB/1aab092" target="_blank" rel="noopener">
            <Img id="App_Store_suxzv1" alt={t('Download the iPhone app')} width={158}/>
          </AppLinks>
          <AppLinks href="https://app.luxuryescapes.com/3WHB/feb04c69" target="_blank" rel="noopener">
            <Img id="Google_Play_o1xn2t" alt={t('Download the Android app')} width={158}/>
          </AppLinks>
        </LinkContainers>
      </SectionContent>
    </Section>
  )
}
